import type { VoidFunctionComponent } from 'react';
import { Icon, icons } from '../../../generic';

type Props = {
  message: string;
};

const ExportIssueModalWarning: VoidFunctionComponent<Props> = ({ message }) => (
  <span className="issues-modal__body__warning">
    <span className="issues-modal__body__warning__icon">
      <Icon icon={icons.infoCircle} />
    </span>
    {message}
  </span>
);

export default ExportIssueModalWarning;
